export default {
  async getAgentsByAverageStatistics(axios, token) {
    return await axios.get('/api/message/agents-by-average/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
